import { render } from "./RequestDetailsCard.vue?vue&type=template&id=05d2f00e"
import script from "./RequestDetailsCard.vue?vue&type=script&lang=js"
export * from "./RequestDetailsCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__